module.exports = __webpack_public_path__ + "static/img/cha-lr-4.0218aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-lr-4.png
// module id = sX3y
// module chunks = 1